import axios, { AUTH_PREFIX } from 'src/clients/axios';

export function getStagingToken(username: any) {
  return axios({
    method: 'post',
    url: `${AUTH_PREFIX}/auth/staging/generate-token`,
    data: { username },
  });
}

export function switchStagingUser(username: any) {
  return axios({
    method: 'post',
    url: `${AUTH_PREFIX}/auth/staging/switch-account`,
    data: { username },
  });
}

export function registerStagingAccount() {
  return axios({
    method: 'post',
    url: `${AUTH_PREFIX}/auth/staging/register`,
  });
}
